module.exports = __webpack_public_path__ + "img/20180414165846.a0a77a87.jpg";